import { render } from "./nft-create.vue?vue&type=template&id=576fb516"
import script from "./nft-create.vue?vue&type=script&lang=js"
export * from "./nft-create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__